import ValidatorMixins from "../../JComponents/JPage/mixins/ValidatorMixins";
import RuleForm from "./RuleForm";

export default {
    components: { RuleForm },
    mixins: [ValidatorMixins],
    data () {
        return {
            desensitiveRule: {
                talent_name: [1],
                talent_id_card: [1, -1],
                household_regist_detail_old: [3],
                household_regist_detail_new: [3]
            },
            dicSelect: [6, 7, 8, 9],
            input: [1, 2, 5],
            searchForms: {},
            searchLoadDic: {},
            forms: {},
            rules: {},
            loadDic: {}
        }
    },
    methods: {
        renderHandle (data, forms, rules, loadDic, result = null) {
            data.forEach(row => {
                // 生成form
                this.fieldHandle(row, forms, rules, loadDic, result)
                // 生成规则
                this.ruleHandle(row, forms, rules, loadDic)
                // 字典引用处理
                this.dictionaryHandle(row, forms, rules, loadDic)
            })
        },
        dictionaryHandle (row, forms, rules, loadDic) {
            if (!row.fieldNeedInput && this.dicSelect.includes(row.fieldInputType)) return
            const { fieldDicKeyInputFormat, fieldInputType } = row
            if (fieldInputType == 13) loadDic['org'] = true
            if (fieldDicKeyInputFormat == 2) loadDic['user'] = true
        },
        fieldHandle (row, forms, rules, loadDic, result) {
            if (!row.fieldNeedInput) return
            const { fieldEng, fieldInputType, fieldValue } = row
            if ([7, 9].includes(fieldInputType)) { // 多选处理
                if (result) forms[fieldEng] = (result[fieldEng] && result[fieldEng].split(',')) || []
                else forms[fieldEng] = (fieldValue === 0 || fieldValue) ? fieldValue.split(',') : []
                return
            }
            if (result) {
                if (fieldInputType == 13) {
                    forms[fieldEng] = (result[fieldEng] && Number(result[fieldEng])) || ''
                } else {
                    forms[fieldEng] = result[fieldEng] || ''
                }
            } else {
                if (fieldInputType == 13) {
                    forms[fieldEng] = (fieldValue && Number(fieldValue)) || ''
                } else {
                    forms[fieldEng] = fieldValue || ''
                }
            }
            // 现居住地特殊处理固定为阿拉尔市
            if (fieldEng === 'household_regist_location_new') forms[fieldEng] = '659002'
        },
        ruleHandle (row, forms, rules, loadDic) {
            if (!row.fieldNeedInput) return
            const { fieldRequired, fieldEng, fieldName, fieldInputType, fieldDicKeyInputFormat } = row
            if (fieldInputType === 1) {
                if (fieldDicKeyInputFormat === 2) return rules[fieldEng] = [{ required: fieldRequired, validator: this.phoneValidator, trigger: ['change', 'blur'] }]
                if (fieldDicKeyInputFormat === 3) return rules[fieldEng] = [{ required: fieldRequired, validator: this.idCardValidator, trigger: ['change', 'blur'] }]
                if (fieldDicKeyInputFormat === 4) return rules[fieldEng] = [{ required: fieldRequired, validator: this.emailValidator, trigger: ['change', 'blur'] }]
            }
            rules[fieldEng] = [{ required: fieldRequired, message: `${this.input.includes(fieldInputType) ? '请输入' : '请选择'}${fieldName}`, trigger: ['change', 'blur'] }]
        }
    }
}
